import { render, staticRenderFns } from "./customer-repayment-schedule-kh.vue?vue&type=template&id=1c57c1e8&scoped=true&"
import script from "./customer-repayment-schedule-kh.vue?vue&type=script&lang=js&"
export * from "./customer-repayment-schedule-kh.vue?vue&type=script&lang=js&"
import style0 from "./customer-repayment-schedule-kh.vue?vue&type=style&index=0&id=1c57c1e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c57c1e8",
  null
  
)

export default component.exports